import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const CampaignUmbrellaDetailRBAC = {
  pageID: '0e803512183f4015562b1aa0b8b5d6d8',
  elementID: {
    ViewPage: '0492248c456b31123c4a4f9ba740eece',
    EditUmbrella: '4cac6150cf7fa7b36fdf7d139dd74618',
    AddChild: 'a99781830a6b3111e1e1d912c82aa089',
    DeleteChild: 'ca9dd5df81d6512c70347d4d91324681',
    ReviewChild: '2f8244e02c441a35e9f8e223019e6676',
    DetailChild: 'f4d20f405ad6510166da1ef2393b3d13',
  },
} as const

export const useRBACCampaignUmbrellaDetailRBAC = createUseRBAC(CampaignUmbrellaDetailRBAC.elementID)

export type UseRBACCampaignUmbrellaDetailRBACType = ReturnType<
  typeof useRBACCampaignUmbrellaDetailRBAC
>
